<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section *ngIf="data" class="page-content">
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <a [routerLink]="'/blogs'">Blogs</a><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li class="active">{{data.title}}</li>
    </ul>

    <!-- HEADING, SOCIAL SHARING & FAVORITE -->
    <ion-grid class="page-header ion-no-padding">
      <ion-row>
        <ion-col>
          <ion-text color="dark">
            <h1 class="h2 page-title">{{data.title}}</h1>
          </ion-text>
          <ion-text color="tertiary">
            <p class="meta">
              <a [routerLink]="'/blogs/category/'+currentCategory?.slug">{{currentCategory?.title | uppercase}}</a>
              &nbsp;|&nbsp; {{data?.updatedAt | date:'d MMM y' | uppercase}}
            </p>
          </ion-text>
        </ion-col>
        <ion-col size="auto" class="page-header-actions">
          <ion-row class="ion-align-items-center ion-justify-content-end">
            <!-- SOCIAL SHARING -->
            <ion-col size="auto" class="social-share">
              <a (click)="presentPopover($event)">
                <ion-icon color="dark" name="share-outline" slot="icon-only"></ion-icon>
              </a>
            </ion-col>
            <!-- FAVORTIE -->
            <ion-col size="auto" class="favorite">
              <app-favorite-item [title]="data.title" [slug]="data.slug"></app-favorite-item>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- FEATURED IMAGE -->
    <app-image [node]="featuredImage" [disableLazyLoad]="true" class="blog-featured-image"
      [sponsor]="data?.advertise"></app-image>

    <!-- BODY -->
    <app-dynamic-html [data]="data?.body" [formTitle]="data.title"></app-dynamic-html>

    <!-- SPONSOR STRIP -->
    <app-sponsor-strip *ngIf="data?.advertise" [sponsorStrip]="data?.advertise"></app-sponsor-strip>
  </section>

  <!-- SIMILAR STORES -->
  <section *ngIf="relatedStores && relatedStores.length > 0"
    class="stores-listing ion-content-stretched swiper-stretched">
    <ion-grid>
      <ion-text color="dark" class="ion-text-center">
        <h2 class="related-content-title">Related Stores</h2>
      </ion-text>
      <ion-row class="ion-nowrap ion-align-items-start">
        <ion-slides pager="true" [options]="slideOpts">
          <ion-slide *ngFor="let item of relatedStores">
            <ion-card (click)="linkToDetail(item)" class="card-boxed card-boxed-mobile">
              <div *ngIf="item.logoImage" class="card-img">
                <app-img-format [src]="item.logoImage" [aspectRatio]="'16:9'"
                  [alt]="item.title + ' in ' + environmentName" [disableLazyLoad]="true"></app-img-format>
              </div>
              <ion-card-header>
                <ion-card-subtitle>
                  <ng-container *ngIf="item.typeGeneral?.new && item.currentStatus.toLowerCase().includes('open')">
                    New Store |
                  </ng-container>
                  {{item.currentStatus}}
                  <ng-container *ngIf="item.currentStatus && item.currentStatus.toLowerCase().includes('open')">
                    | {{ storeOpenClose(item) }}
                  </ng-container>
                </ion-card-subtitle>
                <ion-card-title>{{item.title}}</ion-card-title>
              </ion-card-header>
              <ion-card-content>
                {{item.typeGeneral?.telephone_number}} |
                {{item.typeGeneral?.level}}
              </ion-card-content>
            </ion-card>
          </ion-slide>
        </ion-slides>
      </ion-row>
    </ion-grid>
  </section>

  <!-- RELATED CONTENT -->
  <section *ngIf="relatedContent && relatedContent.length > 0">
    <app-related-content
      [data]="{title: 'More From ' + currentCategory?.title, items: relatedContent }"></app-related-content>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>